import * as angular from 'angular';

import { applicationBackuped } from '../../common/events';
import { IBackupService, IWorkspaceService, ILoggerService } from '../../services';
import { Application, ComponentDefinition, IBackup } from '../../models';

class ApplicationBackupTableController implements angular.IComponentController {
    isLoading: boolean;
    selectedApplication: Application;
    backups: IBackup[];
    selectedBackup: IBackup;
    selectedRowIndex: number;
    workspaceApplication: string;

    private _watchers: (() => void)[] = [];

    static $inject = [
        '$rootScope',
        'backupService',
        'workspaceService',
        'loggerService'
    ];

    constructor(private $rootScope: angular.IRootScopeService,
        private _backupService: IBackupService,
        private _workspaceService: IWorkspaceService,
        private _loggerService: ILoggerService
    ) {
    }

    $onInit() {
        this.backups = [];

        this._watchers.push(this.$rootScope.$on(applicationBackuped, (event, data) => {
            if (data) {
                this.backups = this.mapBackups(data);
            }
        }));

        const workspace = this._workspaceService.getWorkspace();
        if (workspace) {
            this.workspaceApplication = workspace.application;
        }

        return;
    }

    $onDestroy() {
        this._watchers.forEach(w => w());
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['selectedApplication']) {
            if (changesObj['selectedApplication'].currentValue) {
                this.refresh(changesObj['selectedApplication'].currentValue);
            }
            else {
                this.backups = [];
            }
        }
    }

    select(backup, index: number) {
        this.selectedBackup = backup;
        this.selectedRowIndex = index;
    }

    restore(backup) {
        const msgSucess = 'Backup successfully restored .';
        const msgError = 'Could not restore backup.';

        this._backupService.restoreBackup(this.selectedApplication.guid, backup.file)
            .then(success => {
                if (success) {
                    this._loggerService.logSuccess(msgSucess);
                } else {
                    this._loggerService.logError(msgError);
                }
            }).catch(reason => {
                this._loggerService.logError(reason, false);
                this._loggerService.logError(msgError);
            });
    }

    download(backup) {
        this._backupService.downloadBackup(this.selectedApplication.guid, backup.file,
            (data, baseUrl) => {
                try {
                    window.open(`${baseUrl}${data}`);
                } catch (e) {
                    this._loggerService.logError(e);
                }
            }
        );
    }

    private refresh(data: { guid: string }) {
        this.isLoading = true;
        this._backupService
            .getBackups(data.guid)
            .then(backups => this.backups = this.mapBackups(backups))
            .finally(() => this.isLoading = false);
    }

    private mapBackups(backups): IBackup[] {
        return backups.map(b => ({
            name: this.getFileName(b.name),
            file: b.name,
            date: new Date(b.date),
        }));
    }

    private getFileName(filePath: string): string {
        return filePath.substring(filePath.lastIndexOf('\\') + 1);
    }
}

export const wtApplicationBackupTable: ComponentDefinition = {
    componentId: 'wtApplicationBackupTable',
    controller: ApplicationBackupTableController,
    template: require('./applicationBackupTable.component.html'),
    controllerAs: 'vm',
    bindings: {
        selectedApplication: '<?'
    }
};
